module.exports = __webpack_public_path__ + "static/media/app0.9eb5e487.png";